












import Vue from "vue";
import {TileList} from "../models/tile";

export default Vue.extend({
  name: "Tile",
  props: {
    id: Number
  },
  computed: {
    debug(): boolean {
      return process.env.VUE_APP_DEBUG_TILE === "true";
    },
    tileName(): string {
      return TileList[this.id].id;
    }
  }
});
